import { Box, ButtonV2, css, Flex, styled, StyleSystemProps, TextV2 } from '@withjoy/joykit';
import { ButtonOverrides } from '@withjoy/joykit/components/ButtonV2/Button.types';
import { ProductTileProps } from '../../ProductTile.types';

const DEFAULT_IMAGE = 'https://withjoy.com/assets/public/apps/registry/custom-item-default.svg';

export const StyledProductPhoto = styled.div.attrs<{ photoUrl?: string; fullCover?: boolean }>(({ photoUrl, fullCover }) => {
  return {
    style: {
      backgroundImage: photoUrl ? `url("${photoUrl}")` : `url("${DEFAULT_IMAGE}")`,
      backgroundSize: photoUrl ? 'contain' : '50%'
    }
  };
})<{ photoUrl?: string; fullCover?: boolean }>`
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  mix-blend-mode: multiply;
  background-position: center;
  transition: transform 0.25s;
  justify-content: center;
  display: flex;
  transform: scale(1.0001);
  position: absolute;
  top: 0;
`;

export const StyledProductTile = styled(Box)`
  contain: content;
  width: 100%;
  position: relative;
  @media (hover: hover) {
    :hover {
      position: relative;
    }
  }
`;

export const StyledFlex = styled(Flex)``;

export const ProductTitleText = styled(TextV2)<{ $variant: ProductTileProps['variant'] }>`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: 288px;
  text-align: ${props => (props.$variant === 'gridItem' ? 'center' : 'start')};

  ${props => props.theme.mediaQueries.down({ viewport: 'sm' })} {
    -webkit-line-clamp: 3;
  }
`;

export const StyledQuickAddButton = styled(ButtonV2)<{ loading: boolean; $darkBg: boolean }>`
  ${({ $darkBg = false }) =>
    $darkBg
      ? css`
          background-color: transparent;
          color: white;
        `
      : ''}

  svg {
    width: 16px;
    height: 16px;
  }
`;

const buttonTextStyles: StyleSystemProps = {
  color: 'linkText',
  transition: 'color 500ms cubic-bezier(0.23, 1, 0.32, 1) 0s',
  display: 'flex'
};

const brandTextStyles: StyleSystemProps = {
  minHeight: '19px',
  letterSpacing: '-0.015em',
  marginBottom: 1,
  color: 'black',
  textAlign: 'center'
};

const brandTextDarkBgStyles: StyleSystemProps = {
  ...brandTextStyles,
  color: 'white'
};

const productTitleStyles: StyleSystemProps = {
  marginBottom: 1,
  whiteSpace: 'normal'
};

const productTitleDarkBgStyles: StyleSystemProps = {
  ...productTitleStyles,
  color: 'white'
};

const photoWrapperStyles: StyleSystemProps = {
  overflow: 'hidden',
  borderRadius: '4px',
  position: 'relative',
  width: '100%',
  paddingTop: '100%'
};

const flexTextWrapperStyles: StyleSystemProps = {
  paddingTop: 0
};

const storefrontHeadContainerStyles: StyleSystemProps = {
  justifyContent: 'center',
  width: '100%',
  minHeight: '37px'
};

export const quickAddButtonOverrides: ButtonOverrides = {
  Root: {
    props: {
      fontSize: '13px',
      color: 'mono14',
      background: 'white',
      _hover: {
        // eslint-disable-next-line
        color: 'mono14'
      },
      _active: {
        // eslint-disable-next-line
        color: 'mono14'
      }
    }
  }
};
export const hoveredColorSwatchStyles: StyleSystemProps = {
  zIndex: -1
};

export const StyledIcon = styled(Box)`
  position: relative;
  margin: 12px;
  width: 24px;
  svg {
    width: 24px;
    height: 24px;
    color: ${props => props.theme.colors.mono6};
  }
`;

export const styles = {
  brandText: brandTextStyles,
  brandTextDarkBg: brandTextDarkBgStyles,
  buttonText: buttonTextStyles,
  productTitle: productTitleStyles,
  productTitleDarkBg: productTitleDarkBgStyles,
  photoWrapper: photoWrapperStyles,
  flexTextWrapper: flexTextWrapperStyles,
  hovered: hoveredColorSwatchStyles,
  storefrontHeadContainer: storefrontHeadContainerStyles
};
